import { inject, Injectable, Provider } from '@angular/core';
import { OfferGetQueryResult, OfferListGetQueryResult, OrderGetQueryResult, OrderListGetQueryResult, PreOrderListGetQueryResult } from '../../INTEGRA_Shop_Client';
import { IOrderApiService, IOrderApiServiceToken } from '../../api/order/order-api-service.interface';
import { IHistoryService, IHistoryServiceToken } from './history-service.interface';
import { IOfferApiService, IOfferApiServiceToken } from '../../api/offer/offer-api-service.interface';

@Injectable({
  providedIn: 'root'
})
export class HistoryService implements IHistoryService {
  private readonly orderApiService: IOrderApiService;
  private readonly offerApiService: IOfferApiService;

  public constructor() {
    this.orderApiService = inject(IOrderApiServiceToken);
    this.offerApiService = inject(IOfferApiServiceToken);
  }

  public async orderListGetAsync(loadReferences: boolean, orderDateMinimum: Date | undefined): Promise<OrderListGetQueryResult> {
    return await this.orderApiService.orderListGetAsync(loadReferences, orderDateMinimum);
  }

  public async orderGetByDidAsync(integraBelegDid: string | undefined): Promise<OrderGetQueryResult> {
    return await this.orderApiService.orderGetByDidAsync(integraBelegDid);
  }

  public async orderGetByNrAsync(webshopOrderNumber: string | undefined, integraOrderNumber: string | undefined): Promise<OrderGetQueryResult> {
    return await this.orderApiService.orderGetByNrAsync(webshopOrderNumber, integraOrderNumber);
  }

  public async preOrderListGetAsync(): Promise<PreOrderListGetQueryResult> {
    return await this.orderApiService.preOrderListGetAsync();
  }

  public async offerListGetAsync(loadReferences: boolean, offerDateMinimum: Date | undefined): Promise<OfferListGetQueryResult> {
    return await this.offerApiService.offerListGetAsync(loadReferences, offerDateMinimum);
  }

  public async offerGetByDidAsync(integraBelegDid: string | undefined): Promise<OfferGetQueryResult> {
    return await this.offerApiService.offerGetByDidAsync(integraBelegDid);
  }

  public async offerGetbyNrAsync(webshopOfferNumber: string | undefined, integraOfferNumber: string | undefined): Promise<OfferGetQueryResult> {
    return await this.offerApiService.offerGetbyNrAsync(webshopOfferNumber, integraOfferNumber);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const HistoryServiceProvider: Provider[] = [
  { provide: IHistoryServiceToken, useExisting: HistoryService }
];
